var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.refName,staticClass:"lordless-fixed-container",class:{ 'is-leave': _vm.isLeave, 'is-shadow': _vm.shadow, 'is-static': _vm.isStatic, 'initial': _vm.initial },style:(_vm.fixedStyle)},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a4f1590","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stories/fixed/index.vue
// module id = null
// module chunks = 